// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Ry4j","resendInfoText":"OnGoingPaymentBox_resendInfoText__34CKQ"};